<template>
  <v-container class="pt-0" grid-list-lg>
    <card-header></card-header>
    <v-layout row wrap mt-2>
      <v-flex v-for="q in qs" :key="q.id" xs12 sm6 md4 lg3 xl2>
        <q-card v-bind="q"></q-card>
      </v-flex>
    </v-layout>
    <v-layout justify-center wrap class="mt-3">
      <v-btn color="white" @click="getNew" :disabled="isFetching" :loading="isFetching">
        <v-icon left color="primary">add</v-icon>Je veux plus de Q
      </v-btn>
      <v-btn color="white" :to="{name:'home'}" exact>
        <v-icon left color="primary">thumbs_up_down</v-icon>Je veux voter
      </v-btn>
    </v-layout>
  </v-container>
</template>
<script>
import api from "@/plugins/axios";

import CardHeader from "./header";

export default {
  components: { CardHeader },
  data: () => ({
    qs: [],
    isFetching: false
  }),
  created() {
    this.getNew();
  },
  methods: {
    async getNew() {
      if (this.isFetching) return;
      this.isFetching = true;
      const afterRank = this.qs.length;
      const newQs = (await api.get(`q/all?after_rank=${afterRank}`)).data;
      this.qs = this.qs.concat(newQs);
      this.isFetching = false;
    }
  }
};
</script>
